<template>
  <div>
    <v-container class="d-flex justify-center align-center fill-height">
      <v-card class="text-center pa-1" >
  <v-card-text>
        <v-row>
          <v-col>
            <div class="text-right">
              <v-btn
                @click="opensettings"
                style="margin-bottom: -6em; z-index: 99999"
                color="info"
                fab
                dark
                x-small
                outlined
              >
                <v-icon>mdi-cog</v-icon>
              </v-btn>
            </div>
            <v-img
              :src="require('@/assets/images/imglogin.png')"
              class="elevation-0"
              max-height="280"
            ></v-img>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
             v-model="Username"
              label="Username"
              placeholder="user user"
              outlined
            ></v-text-field>
            <v-text-field
              type="password"
               v-model="Password"
              label="Password"
              placeholder="**********"
              outlined
            ></v-text-field>
          </v-col>
     
          <v-col cols="12" class="text-center">
            <v-btn
              color="info"
              rounded
              large
              cols="12"
              class="mr-6"
              @click="login"
              v-if="Loader === false"
           
            >
              Login
            </v-btn>
            <v-btn
             
              rounded
              large
              cols="12"
              class="mr-6"
             v-if="Loader === true"
            >
            <v-icon class="mdi-spin">mdi-refresh</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-center" style="font-size: 14px">
            <b style="color: red"> {{ error }}</b>
          </v-col>
         
        </v-row>
      </v-card-text>
      </v-card>
      </v-container>
 
  </div>
  </template>
  <script>
import axios from "axios";
  export default {
    components: {
   
  },
    data() {
      return {
      snackbar: false,
      SnackbarMessege: "",
      timeout: 1000,
      Username : "",
      Password : "",
      bURL : localStorage.getItem('BaseURL'),
      error:"",
      Loader : false,
     
      };
    },
    watch: {
    
    },
  
    mounted() {
      
       
    },
  methods:{
    GetDashboard()
    {
      this.Loader = false
      this.$router.push("Dashboard");
    },
    login()
    {
       if(this.Username === "" )
       {
          this.SnackbarMessege = "Please enter username"
          this.snackbar = ""
       }
       else if( this.Password === "")
       {
          this.SnackbarMessege = "Please enter password"
          this.snackbar = ""
       }
       else{
              this.Signin()
       }
    },
    Signin()
    {
      this.myobj = {
        "Username" : this.Username,
        "Password" : this.Password,
        "VersionCode" : 2
      }
         this.Loader = true
          axios
          .post(this.bURL + "/api/user/authenticate?isCreateToken=true", this.myobj)
          .then(
            (response) => {
              if (response.data.token != "undefined") {
                localStorage.setItem(
                  "Token",
                  response.data.token
                );
              }
              this.GetCurrency();
            },
            (error) => {
              this.Loader = false
              // console.log("error" + error);
              if (error.response.status === 401) {
                this.error = "Invalid Username or Password";
                this.log_check = true;
              } else {
                this.error = "Something went wrong..!";
                this.log_check = true;
              }
              // localStorage.setItem("Token", error);
            }
          );
    },
    GetCurrency() {
        axios
          .get(this.bURL + "/api/currency/GetPrimaryCurrency")
          .then(
            (response) => {
              localStorage.setItem(
                "GetPrimaryCurrency",
                JSON.stringify(response.data)
              );
              localStorage.setItem(
                "symbol",
                response.data.DecimalPlaces
              );
              localStorage.setItem(
                "Currency",
                response.data.CurrencySymbol
              );

              this.GetUserDetails()

            },
            (error) => {
              console.log("error" + error);
              this.error = "Something went wrong..!";
            }
          );
      
    },
   
    GetUserDetails()
    {
      axios
          .get(this.bURL + "/api/user/Getuser/" + this.Username, null)
          .then(
            (response) => {
              console.table(response.data);
              localStorage.setItem("User",JSON.stringify(response.data))
              this.GetBranchinfo();
            },
            (error) => {
              // this.error = "Something went wrong..!";
            }
          );
    },
    GetBranchinfo()
    {
      axios.get(this.bURL+ "/api/branch", null)
  .then(
    response => {
      // console.log("Result" + JSON.stringify(response.data));
      localStorage.setItem( "Branches", JSON.stringify(response.data) );
      this.GetPermissionObject()
    },
    error => {
      console.log("error" + error);
      this.error = "Something went wrong..!";
    }
  );
    },

     GetPermissionObject()
    {
      this.UserDetails = JSON.parse( localStorage.getItem('User'))
      this.UserDetails.User
      axios.get(this.bURL +"/api/"+ "common/GetAvailableForms/" +this.UserDetails.userType)
  .then(
    response => {
      // console.log("Result" + JSON.stringify(response.data));
       localStorage.setItem('PermissionObject',JSON.stringify(response.data))
      this.GetDashboard()
    },
    error => {
      console.log("error" + error);
      this.error = "Something went wrong..!";
    }
  );
    },
    opensettings() {
      this.$router.push("BasicSettings");
    },
  }
   
  }
  </script>
  